import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SubtleBadge = ({
  bg = 'primary',
  noBg = false,
  pill,
  children,
  className
}) => {
  return (
    <div
      className={classNames(className, `badge badge-subtle-${bg}`, {
        'rounded-pill': pill,
        [`badge-subtle-${bg}-no-bg`]: noBg
      })}
    >
      {children}
    </div>
  );
};

SubtleBadge.propTypes = {
  bg: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'info',
    'warning',
    'danger',
    'light',
    'dark',
    'orange'
  ]),
  pill: PropTypes.bool,
  children: PropTypes.node,
  noBg: PropTypes.bool,
  className: PropTypes.string
};

export default SubtleBadge;
